var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item-avatar',{style:(_vm.style),attrs:{"size":_vm.size,"tile":""}},[_vm._v(" "+_vm._s(_vm.initials)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }